import { render, staticRenderFns } from "./AlertOverlaySection.vue?vue&type=template&id=d6e95d36"
import script from "./AlertOverlaySection.vue?vue&type=script&lang=ts"
export * from "./AlertOverlaySection.vue?vue&type=script&lang=ts"
import style0 from "./AlertOverlaySection.vue?vue&type=style&index=0&id=d6e95d36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports